export default __webpack_public_path__ + "static/media/sign-placeholder-es.65cf5ff5.png";